import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getCurrentAcadid } from "store/Common/Actions"
import { Card, CardBody, Col, Container, Label, Row } from "reactstrap"
import DeleteModal from "./Modal"
import axios from "axios"
import { toast, ToastContainer } from "react-toastify"
import Spinners from "components/Common/Spinner"

const Home = () => {
  const [selectAll, setSelectAll] = useState(false)

  const [data, setData] = useState(null)
  const dispatch = useDispatch()
  const { acadID } = useSelector(state => state.CommonReducer)
  const token = JSON.parse(localStorage.getItem("Token"))
  const [subjectList, setSubjectList] = useState([])
  const [Loading, setLoading] = useState(false)
  const [selected, setSelected] = useState()
  const [div_id, setDivId] = useState(null)
  const [dmodel, setDmodel] = useState(false)
  const [allDiv, setAllDiv] = useState([])
  const [divName, setDivName] = useState("")
  const [selectedSubjectIds, setSelectedSubjectIds] = useState([])
  const [teacherAccess, setSubjectTeacher] = useState([])

  const [postData, setPostData] = useState({
    acadId: acadID.acadid,
    classDivId: div_id,
    subjectId: selectedSubjectIds,
    isClassTeacher: selected,
  })

  const getClassDivision = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_LIVE_API_URL}/api/tscommon/all-new-div`,
        {
          sid: localStorage.getItem("sid"),
        }
      )
      setAllDiv(res.data)
    } catch (error) {
      console.log(error)
    }
  }

  const getSubjectAll = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_LIVE_API_URL}/api/tscommon/division_subject`,
        {
          acad_id: acadID.acadid,
          div_id: div_id,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      )
      setSubjectList(res.data)
    } catch (error) {
      console.log(error)
    }
  }

  const getSubjectAccessReport = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_LIVE_API_URL}/api/teacher-subjectAccess/getAllSubjectAccessRequests`,
        {
          headers: {
            Authorization: token,
          },
        }
      )
      setData(res.data.data)
    } catch (error) {
      console.error("Error fetching access data:", error)
    }
  }

  const handleDivisionChange = e => {
    const selectedDivision = JSON.parse(e.target.value)
    setDivName(selectedDivision.name)
    setDivId(selectedDivision.id)
    setDmodel(true)

    const rawAccess =
      data?.filter(item => item.class_div_id === selectedDivision.id) || []

    const filtered = rawAccess.filter(
      item =>
        item.subjects !== null &&
        item.subject_id !== null &&
        item.subject_id.trim() !== "" &&
        item.status === 1
    )

    setSubjectTeacher(filtered)

    const subjectIdSet = new Set()

    filtered.forEach(item => {
      const ids = item.subject_id
        .split(",")
        .map(id => parseInt(id))
        .filter(id => !isNaN(id))
      ids.forEach(id => subjectIdSet.add(id))
    })

    setSelectedSubjectIds([...subjectIdSet])
  }

  const onClickYes = () => {
    setDmodel(false)
    setSelected(0)
  }

  const onCloseClick = () => {
    setDmodel(false)
    setSelected(1)
  }

  const handleCheckboxChange = id => {
    setSelectedSubjectIds(prev =>
      prev.includes(id)
        ? prev.filter(subjectId => subjectId !== id)
        : [...prev, id]
    )
  }

  const handleSubmitRequest = async () => {
    if (!postData) return
    try {
      setLoading(true)
      const apiToken = JSON.parse(localStorage.getItem("Token"))
      const response = await axios.post(
        `${process.env.REACT_APP_LIVE_API_URL}/api/teacher-subjectAccess/requestSubjectAccess`,
        postData,
        {
          headers: {
            Authorization: apiToken,
          },
        }
      )
      setLoading(false)
      toast.success(response.data.message)
      if (response.data.message === "Request Created Successfully!!") {
        setPostData({
          acadId: "",
          classDivId: "",
          subjectId: [],
          isClassTeacher: selected,
        })
        setSelectedSubjectIds([])
      }
    } catch (error) {
      setLoading(false)
      console.error("Error submitting request:", error)
    }
  }

  useEffect(() => {
    if (localStorage.getItem("sid")) {
      dispatch(
        getCurrentAcadid({
          sid: localStorage.getItem("sid"),
        })
      )
    }
    getClassDivision()
    getSubjectAccessReport()
  }, [dispatch])

  useEffect(() => {
    if (acadID.acadid && div_id) {
      getSubjectAll()
    }
  }, [acadID.acadid, div_id])

  useEffect(() => {
    setPostData({
      acadId: acadID.acadid,
      classDivId: div_id,
      subjectId: selectedSubjectIds,
      isClassTeacher: selected,
    })
  }, [acadID.acadid, div_id, selectedSubjectIds, selected])

  if (Loading) {
    return (
      <div className="page-content">
        <Spinners />
      </div>
    )
  }

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedSubjectIds([])
      setSelectAll(false)
    } else {
      const allIds = subjectList.map(subject => subject.id)
      setSelectedSubjectIds(allIds)
      setSelectAll(true)
    }
  }

  return (
    <>
      <DeleteModal
        show={dmodel}
        onCloseClick={onCloseClick}
        onClickYes={onClickYes}
        allDiv={divName}
      />
      <div className="page-content px-0" style={{ paddingTop: "90px" }}>
        <Container>
          <Card className="p-1">
            <CardBody className="p-1">
              <h1
                className="text-center mb-4 fs-3"
                style={{ color: "#3c3c3c" }}
              >
                Request for Subject
              </h1>
              <Row>
                <Col xl="12" md="12" sm="12" className="mt-1">
                  <select className="form-select" disabled>
                    <option value="">{acadID?.academics}</option>
                  </select>
                </Col>
                <Col xl="4" className="mt-3">
                  <select
                    className="form-select"
                    onChange={handleDivisionChange}
                  >
                    <option value="">Select Divisions</option>
                    {allDiv?.map(classDiv => (
                      <option
                        key={classDiv.id}
                        value={JSON.stringify({
                          id: classDiv.id,
                          name: classDiv.div_name,
                        })}
                      >
                        {classDiv.div_name}
                      </option>
                    ))}
                  </select>
                </Col>

                {(selected === 0 || selected === 1) && (
                  <>
                    <Col xl="4" className="mt-3">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <Label
                          className="form-check-label fw-bold"
                          htmlFor="selectAllCheckbox"
                        >
                          Select All
                        </Label>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          style={{ transform: "scale(1.5)", margin: "5px" }}
                          id="selectAllCheckbox"
                          checked={selectAll}
                          onChange={handleSelectAll}
                        />
                      </div>
                    </Col>
                    <Col xl="4" className="mt-2">
                      {subjectList &&
                        subjectList.length > 0 &&
                        subjectList.map(sub => (
                          <div key={sub.id}>
                            <input
                              type="checkbox"
                              id={`sub-${sub.id}`}
                              style={{ height: 20, width: 20 }}
                              className="form-check-input"
                              onChange={() => handleCheckboxChange(sub.id)}
                              checked={selectedSubjectIds.includes(sub.id)}
                            />
                            <Label
                              htmlFor={`sub-${sub.id}`}
                              check
                              style={{ marginLeft: 4 }}
                              className="form-check-label mt-1"
                            >
                              {sub.subject}
                            </Label>
                          </div>
                        ))}
                    </Col>
                  </>
                )}
              </Row>

              <div className="d-flex mt-4 align-items-center justify-content-center">
                <button
                  onClick={handleSubmitRequest}
                  className="btn btn-primary"
                >
                  Submit
                </button>
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>
      <ToastContainer />
    </>
  )
}

export default Home
